<script setup lang="ts">
import { onMounted } from 'vue'
import Introlbanner from './pc/Introlbanner.vue'
import Map from './pc/map.vue'
import Milestones from './pc/Milestones.vue'
onMounted(() => { })
</script>

<template>
  <main>
    <Introlbanner />
    <Map />
    <Milestones />
  </main>
</template>

<style lang="scss" scoped>
main {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3.6rem;
  align-self: stretch;
  background-color: #f2f2f2;
  padding: 2.4rem 1.6rem;
}
</style>
